import React from 'react';

import AuthUserContext from './AuthUserContext';
import { PasswordForgetForm } from './PasswordForget';
import PasswordChangeForm from './PasswordChange';
import withAuthorization from './withAuthorization';


const AccountPage = () =>
  <AuthUserContext.Consumer>
    {authUser =>
      <div>
        <h1>Account: {authUser.displayName!=null?authUser.displayName:authUser.email}</h1>
        <PasswordForgetForm />
        <PasswordChangeForm />
      </div>
    }
  </AuthUserContext.Consumer>


const authCondition = (authUser) => !!authUser;
// const authCondition = (authUser) => !!authUser && authUser.role === 'ADMIN';
// export default AccountPage;

export default withAuthorization(authCondition)(AccountPage);



// WEBPACK FOOTER //
// ./src/components/Account.js